export default __webpack_public_path__ + "static/media/wbtc_w.bfd902ee.svg";